import { Component, OnInit } from '@angular/core';
import { SelectedWidgets, WidgetStatus } from '@flyfreely-portal-ui/widget';
import {
    CurrentOrganisation,
    WorkspaceStateService
} from '@flyfreely-portal-ui/workspace';
import { Angulartics2 } from 'angulartics2';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ManageDashboardWidgetsService } from '../manage-dashboard-widgets.service';

@Component({
    selector: 'widget-selection',
    templateUrl: './widget-selection.component.html',
    styleUrls: ['./widget-selection.component.scss']
})
export class WidgetSelectionComponent implements OnInit {
    widgets: WidgetStatus = {};

    currentOrganisation?: CurrentOrganisation;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private sharedService: WorkspaceStateService,
        private manageDashboardWidgetsService: ManageDashboardWidgetsService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit(): void {
        this.manageDashboardWidgetsService.availableWidgets$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((widgets: WidgetStatus) => {
                this.widgets = widgets;
            });

        this.sharedService.currentOrganisation$
            .pipe(
                filter<CurrentOrganisation>(
                    o => o.type === 'organisation_loaded'
                )
            )
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(organisation => {
                this.currentOrganisation = organisation;
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    onMenuChanged() {
        this.angulartics2.eventTrack.next({
            action: 'toggle',
            properties: {
                category: 'sidebar'
            }
        });

        const selectedWidgets: SelectedWidgets = Object.keys(
            this.widgets
        ).reduce(
            (acc, w) => ({ ...acc, [w]: this.widgets[w].selected }),
            {} as SelectedWidgets
        );

        this.manageDashboardWidgetsService.changeSelectedWidgets(
            selectedWidgets
        );
    }

    public scrollTo(widgetId: string) {
        this.manageDashboardWidgetsService.scrollTo(widgetId);

        this.angulartics2.eventTrack.next({
            action: 'scrollTo',
            properties: {
                category: 'sidebar',
                label: widgetId
            }
        });
    }
}
